import { baseUrl } from "../api";

export const mediaItemsUrl = `${baseUrl}media-items/`;
